import Storage from 'utils/Storage';
import { logoutUser } from 'store/User';

type Dispatch = ( action: ReturnType<typeof logoutUser> ) => void;

type ClearAuthSessionOptions = {
  clearPersist?: boolean;
};

export default function clearAuthSession(
  dispatch?: Dispatch,
  { clearPersist = true }: ClearAuthSessionOptions = {},
) {
  Storage.clear( 'grupoimpar:token' );
  if ( clearPersist ) {
    Storage.clear( 'persist:grupoimpar' );
  }
  dispatch?.( logoutUser() );
}
